"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _customPropTypes = require("../../helpers/customPropTypes");

var _getHashFromString = require("../../helpers/getHashFromString");

var _getHashFromString2 = _interopRequireDefault(_getHashFromString);

require("./Avatar.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getInitialsFromSingleChunk = function getInitialsFromSingleChunk(chunk) {
  return chunk.length === 1 ? chunk[0] : chunk[0] + chunk[1];
};

var getInitialsFromEmailAddress = function getInitialsFromEmailAddress(emailAddress) {
  var name = emailAddress.substr(0, emailAddress.indexOf("@")).toUpperCase();
  var nameChunks = name.split(/[_.-]/g);
  nameChunks = nameChunks.filter(function (chunk) {
    return chunk.length > 0;
  });
  if (nameChunks.length === 0) {
    return "";
  } else if (nameChunks.length === 1) {
    return getInitialsFromSingleChunk(nameChunks[0]);
  }
  return nameChunks[0][0] + nameChunks[1][0];
};

var getInitialsFromName = function getInitialsFromName(userName) {
  var userNameArray = userName.split(" ");
  var getFirstLetter = function getFirstLetter(str) {
    return str.substr(0, 1).toUpperCase();
  };
  return getFirstLetter(userNameArray[0]) + (userNameArray[1] ? getFirstLetter(userNameArray[1]) : "");
};

var getInitialsFromEmailOrName = function getInitialsFromEmailOrName(userName) {
  return userName.includes("@") ? getInitialsFromEmailAddress(userName) : getInitialsFromName(userName);
};

var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      hasBorder = _ref.hasBorder,
      isPlainText = _ref.isPlainText,
      size = _ref.size,
      userName = _ref.userName,
      moreProps = _objectWithoutProperties(_ref, ["className", "hasBorder", "isPlainText", "size", "userName"]);

  var autoWidthClassName = isPlainText ? "aclui-avatar--auto-width-" + size : null;
  var borderClassName = hasBorder ? "aclui-avatar--has-border" : null;
  var colorClassName = "aclui-avatar--" + (0, _getHashFromString2.default)(userName, 12);
  var sizeClassName = "aclui-avatar--" + size;
  var avatarClassName = (0, _classnames2.default)(className, "aclui-avatar", autoWidthClassName, borderClassName, colorClassName, sizeClassName);

  return _react2.default.createElement(
    "span",
    _extends({ alt: userName, "aria-label": userName, role: "img", className: avatarClassName }, moreProps),
    isPlainText ? userName : getInitialsFromEmailOrName(userName)
  );
};

Avatar.propTypes = {
  /** Custom class name */
  className: _propTypes.string,
  /** Does avatar have border */
  hasBorder: _propTypes.bool,
  /** Renders plain text instead of user initials */
  isPlainText: _propTypes.bool,
  /** Shirt size of Avatar */
  size: _customPropTypes.shirtSize,
  /** User Name string */
  userName: _propTypes.string
};

Avatar.defaultProps = {
  className: null,
  hasBorder: false,
  isPlainText: false,
  size: "medium",
  userName: ""
};

exports.default = Avatar;